// @flow

import type { ACFImage } from '../../../types';

export const getMinimalColumnHeight = (images: ACFImage, breakpoint: string, padding: string) => {
  switch (breakpoint) {
    case 'default':
    case 'sm':
    case 'md':
      return `calc(${images.sizes['medium-height']}px + ${padding})`;
    default:
      return `calc(${images.sizes['large-height']}px + ${padding})`;
  }
};

export default null;
